<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">地图详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="子系统编码" prop="SysCode">
                <el-input v-model="ruleForm.SysCode" disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地图编码" prop="UKey">
                <el-input v-model="ruleForm.UKey" :disabled="IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="地图名称" prop="UKeyName">
                <el-input v-model="ruleForm.UKeyName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="描述" prop="Description">
                <el-input v-model="ruleForm.Description"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度" prop="Longitude">
                <el-input v-model="ruleForm._Longitude"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="纬度" prop="Latitude">
                <el-input v-model="ruleForm._Latitude"></el-input>
              </el-form-item>
            </el-col>
            <ZjLngLatSelect
              class="newtaskposition"
              :point_lat="ruleForm._Latitude"
              :point_lng="ruleForm._Longitude"
              @onGotLngLat="onGotLngLat"
            ></ZjLngLatSelect>
            <!-- <el-button @click="getCurrentPostion()" style="margin-left:1.5rem;">定位</el-button> -->
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="使用GL地图" prop="UValue.mapMode">
                <el-checkbox v-model="ruleForm.UValue.mapMode"></el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="显示3D控件"
                prop="UValue.navigationControl3D"
              >
                <el-checkbox
                  v-model="ruleForm.UValue.navigationControl3D"
                ></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="地图倾斜角度" prop="UValue.tilt">
                <el-input-number
                  v-model="ruleForm.UValue.tilt"
                  :min="0"
                  :max="360"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地图旋转角度" prop="UValue.heading">
                <el-input-number
                  v-model="ruleForm.UValue.heading"
                  :min="0"
                  :max="360"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="最小缩放级别" prop="UValue.minZoom">
                <el-input-number
                  v-model="ruleForm.UValue.minZoom"
                  :min="4"
                  :max="19"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最大缩放级别" prop="UValue.maxZoom">
                <el-input-number
                  v-model="ruleForm.UValue.maxZoom"
                  :min="4"
                  :max="19"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="默认缩放级别" prop="UValue.zoom">
                <el-input-number
                  v-model="ruleForm.UValue.zoom"
                  :min="4"
                  :max="19"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地图类型" prop="UValue.mapType">
                <el-select
                  v-model="ruleForm.UValue.mapType"
                  placeholder="请选择"
                  v-if="!ruleForm.UValue.mapMode"
                >
                  <el-option
                    key="NORMAL_MAP"
                    value="NORMAL_MAP"
                    label="普通街道视图"
                  ></el-option>
                  <el-option
                    key="PERSPECTIVE_MAP"
                    value="PERSPECTIVE_MAP"
                    label="透视图像视图"
                  ></el-option>
                  <el-option
                    key="SATELLITE_MAP"
                    value="SATELLITE_MAP"
                    label="卫星视图"
                  ></el-option>
                  <el-option
                    key="HYBRID_MAP"
                    value="HYBRID_MAP"
                    label="卫星和路网的混合视图"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="ruleForm.UValue.mapType"
                  placeholder="请选择"
                  v-else
                >
                  <el-option
                    key="NORMAL_MAP"
                    value="NORMAL_MAP"
                    label="普通街道视图"
                  ></el-option>
                  <el-option
                    key="EARTH_MAP"
                    value="EARTH_MAP"
                    label="地球卫星视图"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="地图样式">
                <el-select v-model="ruleForm.UValue.mapStyle.ServiceData.Key">
                  <el-option
                    v-for="item in mapStyles"
                    :key="item._UKey"
                    :value="item._UKey"
                    :label="item._UKeyName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="瓦片路径" prop="UValue.tilesPath">
                <el-input v-model="ruleForm.UValue.tilesPath"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="瓦片地址" prop="UValue.tileUrlTpl">
                <el-input v-model="ruleForm.UValue.tileUrlTpl"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="点击显示经纬度"
                prop="UValue.clickToShowLocation"
              >
                <el-checkbox
                  v-model="ruleForm.UValue.clickToShowLocation"
                ></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="坐标拾取" prop="UValue.reportGeo">
                <el-checkbox v-model="ruleForm.UValue.reportGeo"></el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="显示开关面板"
                prop="UValue.togglePanelVisiable"
              >
                <el-checkbox
                  v-model="ruleForm.UValue.togglePanelVisiable"
                ></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="默认收起开关面板"
                prop="UValue.togglePanelCollapsed"
              >
                <el-checkbox
                  v-model="ruleForm.UValue.togglePanelCollapsed"
                ></el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开关面板视图样式" prop="toggleTool">
                <el-select
                  v-model="ruleForm.UValue.toggleTool"
                  placeholder="请选择"
                >
                  <el-option
                    key="tool/Toggle"
                    value="tool/Toggle"
                    label="普通视图"
                  ></el-option>
                  <el-option
                    key="tool/TreeToggle"
                    value="tool/TreeToggle"
                    label="树状视图"
                  ></el-option>
                  <el-option
                    key="tool/CombineToggle"
                    value="tool/CombineToggle"
                    label="分组视图"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="所在城市" prop="city">
                <el-input v-model="ruleForm.UValue.city"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="显示城市边界线" prop="UValue.cityBoundary">
                <el-checkbox
                  v-model="ruleForm.UValue.cityBoundary"
                ></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="边界线宽度"
                prop="UValue.cityBoundaryStyle.strokeWeight"
              >
                <el-input
                  v-model="ruleForm.UValue.cityBoundaryStyle.strokeWeight"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="边界线样式"
                prop="UValue.cityBoundaryStyle.strokeStyle"
              >
                <el-select
                  v-model="ruleForm.UValue.cityBoundaryStyle.strokeStyle"
                  placeholder="请选择"
                >
                  <el-option
                    key="dashed"
                    value="dashed"
                    label="虚线"
                  ></el-option>
                  <el-option key="solid" value="solid" label="实线"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="边界线颜色"
                prop="UValue.cityBoundaryStyle.strokeColor"
              >
                <el-color-picker
                  v-model="ruleForm.UValue.cityBoundaryStyle.strokeColor"
                ></el-color-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="缩放地图以显示城市"
                prop="UValue.viewportToCityBoundary"
              >
                <el-checkbox
                  v-model="ruleForm.UValue.viewportToCityBoundary"
                ></el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="地图不能拖出城市范围"
                prop="UValue.restrictMapArea"
              >
                <el-checkbox
                  v-model="ruleForm.UValue.restrictMapArea"
                ></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="显示图层" prop="UValue.mapLayers">
                <el-checkbox-group class="zj-map-layers" v-model="mapLayersSelected">
                  <el-checkbox
                    v-for="item in mapLayers"
                    :key="item.key"
                    :value="item.key"
                    :label="item.title"
                  >
                    <img :src="getIconUrl(item.icon)" />
                    {{ item.title }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button type="primary" @click="saveForm()">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../apis";
import ZJApp from "../../../../app";

export default {
  name: "MapAdminEdit",
  controller: "Home",
  action: "MapAdminEdit",
  props: {
    query: {
      syscode: {
        type: String,
        required: true,
        default: "ZJMap",
      },
      ukey: {
        type: String,
        required: true,
        default: "DefaultMap",
      },
      type: {
        type: String,
        required: true,
        default: "add",
      },
    },
  },
  data() {
    return {
      IsEdit: false,
      currentPage: 1,
      pageSize: 100,
      total: 0,
      ruleForm: {
        SysCode: "ZJMap",
        _Latitude: 0,
        _Longitude: 0,
        UValue: {
          mapMode: false, //地图模式 false 平面地图，true GL地图
          heading: 0,
          tilt: 0,
          navigationControl3D: false, //是否开启3D控件
          center: [0, 0],
          minZoom: 0,
          maxZoom: 0,
          zoom: 0,
          mapType: "",
          mapStyle: {
            ServiceData: {
              Key: "",
            },
          },
          tilesPath: "",
          tileUrlTpl: "",
          clickToShowLocation: false,
          reportGeo: false,
          togglePanelVisiable: false,
          togglePanelCollapsed: false,
          toggleTool: "",
          city: "",
          cityBoundary: false,
          cityBoundaryStyle: {
            strokeWeight: 0,
            strokeStyle: "solid",
            strokeColor: "#000000",
          },
          viewportToCityBoundary: false,
          restrictMapArea: false,
          mapLayers: "",
        },
      },
      mapStyles: [],
      mapLayers: [],
      mapLayersSelected: [],
      rules: {},
    };
  },
  created: function () {
    let that = this;
    that.searchMapStyle(this.query.syscode || "ZJMap");
  },
  mounted: function () {
    let that = this;
    this.$nextTick(function () {
      that.search(
        this.query.syscode || "ZJMap",
        this.query.ukey || "DefaultMap"
      );
    });
  },
  watch: {
    query: {
      handler: function (val, oldVal) {
        console.log(val, oldVal);
        this.IsEdit = this.query.type && this.query.type == "edit";
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onGotLngLat(obj) {
      this.ruleForm._Latitude = obj.lat || 0;
      this.ruleForm._Longitude = obj.lng || 0;
    },
    search(syscode, ukey) {
      this.getCurrentMapConfig(syscode, ukey);
    },
    searchMapStyle(syscode) {
      let that = this;
      this.getAllMapStyle(syscode).then(
        function (r) {
          that.mapStyles = r;
        },
        function (e) {
          console.log(e);
        }
      );
    },
    getCurrentMapConfig(syscode, ukey) {
      console.log(new Date());
      let that = this;
      let searchInfo = {
        PageSize: 1,
        PageIndex: 1,
        SysCode: syscode,
        key: ukey,
      };
      new MyApis.UniformConfigApi()
        .GetConfigPagingList(searchInfo)
        .then((r) => {
          console.log(new Date());
          r = r.data.Data;
          let item = r.PageContents[0];
          try {
            let uvalue = JSON.parse(item.UValue);
            uvalue.mapType = uvalue.mapType.replace("BMAP_", "");
            item.UValue = uvalue;
            item._Longitude =
              Array.isArray(uvalue.center) && uvalue.center.length == 2
                ? uvalue.center[0]
                : 0;
            item._Latitude =
              Array.isArray(uvalue.center) && uvalue.center.length == 2
                ? uvalue.center[1]
                : 0;
            var arr = that.getMapLayerNames(uvalue.mapLayers).split(",");
            var dic = [];
            // eslint-disable-next-line no-undef
            $(arr).each(function (idx, item) {
              dic.push(item);
            });

            that.mapLayersSelected = dic;
          } catch (ex) {
            console.error(ex, item.UValue);
          }

          item.UKey = this.IsEdit ? item.UKey : "";
          // eslint-disable-next-line no-undef
          this.ruleForm = $.extend({}, this.ruleForm, item);
          console.log(item);
          this.total = r.BaseSearch.TotalCount;

          let layerSysCode;
          let layerKey;

          if (
            item.UValue.layerDefineFile &&
            item.UValue.layerDefineFile.ServiceData
          ) {
            layerSysCode = item.UValue.layerDefineFile.ServiceData.SysCode;
            layerKey = item.UValue.layerDefineFile.ServiceData.Key;
          }
          layerSysCode = layerSysCode || "ZJMap";
          layerKey = layerKey || "DefaultMapLayers";
          console.log(layerSysCode, layerKey);
          this.getLayers(layerSysCode, layerKey)
            .then((rr) => {
              rr = rr.UValue;
              var allLayers = [];
              for (var k in rr) {
                var v = rr[k];
                if (v && v.UI && v.UI.show) {
                  allLayers.push({ key: k, icon: v.icon, title: v.title });
                }
              }
              console.log(allLayers);
              this.mapLayers = allLayers;
            })
            .catch((ee) => {
              this.$message({
                type: "error",
                message: ee.RspMsg ? ee.RspMsg : "服务异常，请联系管理员！",
              });
            });
        })
        .catch((e) => {
          this.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    getAllMapStyle(syscode) {
      // eslint-disable-next-line no-undef
      let def = $.Deferred();
      syscode = syscode || this.query.syscode;

      let searchInfo = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        SysCode: syscode,
      };
      new MyApis.UniformConfigApi()
        .GetConfigPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          let confs = r.PageContents;
          let styles = [];
          if (confs && confs.length) {
            for (var i = 0, len = confs.length; i < len; i++) {
              let item = confs[i];
              let style;

              try {
                style = JSON.parse(item.UValue);
                console.log(style);
                // eslint-disable-next-line no-empty
              } catch {}

              if (style.UI && style.UI.type === "map-styles") {
                // eslint-disable-next-line no-undef
                style = $.extend({}, style);
                style._SysCode = item.SysCode;
                style._UKey = item.UKey;
                style._UKeyName = item.UKeyName;
                style._Description = item.Description;
                style._Conf = item;
                styles.push(style);
              }
            }

            //按照 _Description 排序
            // eslint-disable-next-line no-undef
            QuickSort.sort(styles, function (a, b) {
              if (a._UKey == "DefaultMapStyle") return -1;
              else if (b._UKey == "DefaultMapStyle") return 1;
              if (a._UKeyName < b._UKeyName) return -1;
              else if (a._UKeyName > b._UKeyName) return 1;
              else return 0;
            });

            def.resolve(styles, true);
          }
        })
        .catch((e) => {
          def.reject(e);
        });

      return def.promise();
    },
    getLayers(layerSysCode, layerKey) {
      let that = this;
      // eslint-disable-next-line no-undef
      let def = $.Deferred();
      let searchInfo = {
        SysCode: layerSysCode,
        Key: layerKey,
      };
      console.log(searchInfo);
      new MyApis.UniformConfigApi()
        .GetDataBySearch(searchInfo)
        .then((r) => {
          r = r.data.Data;
          let conf = r;
          try {
            conf.UValue = JSON.parse(conf.UValue);
          } catch (ex) {
            console.error(ex, conf.UValue);
          }

          if (conf && conf.UValue) {
            var link = conf.UValue;
            //处理继承
            for (var k in link) {
              // eslint-disable-next-line no-prototype-builtins
              if (!link.hasOwnProperty(k)) continue;
              var v = link[k];
              v = that.inherit(v, link);
              link[k] = v;
            }
          }
          def.resolve(conf, true);
        })
        .catch((e) => {
          def.reject(e);
        });

      return def.promise();
    },
    getMapLayerNames(lys) {
      if (typeof lys === "string") {
        return lys;
      }
      var arr = [];
      for (var i = 0; i < lys.length; i++) {
        var item = lys[i];
        if (typeof item === "string") arr.push(item);
        else arr.push(item.name);
      }
      return arr.join(",");
    },
    //处理继承
    inherit(v, link) {
      let that = this;
      if (v && v.inherit) {
        v._inherit = v.inherit;
        delete v.inherit;
        var base = link[v._inherit];
        base = that.inherit(base, link);
        var ui = v.UI;
        // eslint-disable-next-line no-undef
        v = $.extend({}, base, v);
        if (base.UI) {
          // eslint-disable-next-line no-undef
          v.UI = $.extend({}, base.UI, ui);
          for (var k in base.UI) {
            //不继承 infoTpl 属性
            if (k === "infoTpl") continue;
            // eslint-disable-next-line no-prototype-builtins
            if (!base.UI.hasOwnProperty(k)) continue;
            if (typeof base.UI[k] === "object" && typeof ui[k] === "object") {
              // eslint-disable-next-line no-undef
              v.UI[k] = $.extend({}, base.UI[k], ui[k]);

              for (var k2 in base.UI[k]) {
                // eslint-disable-next-line no-prototype-builtins
                if (!base.UI[k].hasOwnProperty(k2)) continue;
                if (
                  typeof base.UI[k][k2] === "object" &&
                  typeof v.UI[k][k2] === "object"
                ) {
                  // eslint-disable-next-line no-undef
                  v.UI[k][k2] = $.extend({}, base.UI[k][k2], v.UI[k][k2]);
                }
              }
            }
          }
        }
      }
      return v;
    },
    getIconUrl(icon) {
      // eslint-disable-next-line no-undef
      return ZJMap.getUrl(icon);
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    saveForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      var data = JSON.parse(JSON.stringify(this.ruleForm));
      data.UValue.center = [data._Longitude || 0, data._Latitude || 0];
      data.UValue.mapLayers = this.mapLayersSelected.join(",");
      data.UValue = JSON.stringify(data.UValue); //UValue转换为JSON字符串

      if (this.IsEdit) {
        new MyApis.UniformConfigApi()
          .UpdateConfig(data)
          .then((r) => {
            if (r && r.data && r.data.RspCode === "1") {
              this.$message({
                type: "success",
                message: "保存成功",
              });

              this.$router.go(-1); //返回上一层
            } else {
              console.log(r);
              this.$message({
                type: "success",
                message: r.data.RspMsg ? r.data.RspMsg : "保存失败！",
              });
            }
          })
          .catch((e) => {
            this.$message({
              type: "error",
              message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
            });
          });
      } else {
        data.ConfigId = ZJApp.ZJUtils.uuid();
        data.Creater = ZJApp.ZJUser.current.UserName;
        data.CreateTime = new Date();
        data.Modifier = ZJApp.ZJUser.current.UserName;
        data.ModifyTime = new Date();
        data.Validity = 1;
        data.ClientCode = "BasicSystem"; //TODO
        data.ClientVersion = "Alpha"; //TODO
        data.DataVersion = "Alpha"; //TODO
        data.UKeyType = 3;

        new MyApis.UniformConfigApi()
          .AddConfig(data)
          .then((r) => {
            if (r && r.data && r.data.RspCode === "1") {
              this.$message({
                type: "success",
                message: "保存成功",
              });
            } else {
              console.log(r);
              this.$message({
                type: "success",
                message: r.data.RspMsg ? r.data.RspMsg : "保存失败！",
              });
            }
          })
          .catch((e) => {
            this.$message({
              type: "error",
              message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
            });
          });
      }
    },
  },
};
</script>

<style>

.zj-map-layers{
  display: flex;
  flex-wrap: wrap;
} 

.zj-map-layers .el-checkbox {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.zj-map-layers .el-checkbox__label {
  display: flex !important;
  align-items: center !important;
  min-width: 120px;
}

.zj-map-layers .el-checkbox__label img{
  margin-right: 5px;
}

</style>